import { useEffect, useRef } from "react";
import { useAtom } from "@xoid/react";
import {
  recyclerFillAtom,
  stopRecyclerFillSession,
  getRecyclerFillStatus,
  type RecyclerFillEvent,
  type RecyclerFillStatus,
} from "@/lib/recycler-fill-events";

export type { RecyclerFillEvent, RecyclerFillStatus };

export type RecyclerFillEventFilter = (event: RecyclerFillEvent) => boolean;

interface UseRecyclerFillEventsOptions {
  filter?: RecyclerFillEventFilter;
  onEvent?: (event: RecyclerFillEvent) => void;
}

export function useRecyclerFillEvents(
  options: UseRecyclerFillEventsOptions = {},
) {
  const { filter, onEvent } = options;
  const state = useAtom(recyclerFillAtom);
  const processedCountRef = useRef(state.events.length);

  useEffect(() => {
    if (!onEvent) return;

    const events = state.events;
    const newEvents = events.slice(processedCountRef.current);

    for (const event of newEvents) {
      if (!filter || filter(event)) {
        onEvent(event);
      }
    }

    processedCountRef.current = events.length;
  }, [state.events, filter, onEvent]);

  return {
    status: state.status,
    connected: state.connected,
    error: state.error,
    stopSession: stopRecyclerFillSession,
    getStatus: getRecyclerFillStatus,
  };
}
